import { ServService } from '../services/serv.service';
import { Estate } from '../utils/enum.util';
import { ValidatorService, EvalidatorRequire } from '../services/validator.service';
import { BikeModel } from './bike.model';

export class ServModel {

    private _privateId: string      = null;
    private _about: string          = null;
    private _created: Date;
    private _client: any;
    private _clientPrivateId: string;
    private _process: string;
    private _nbrService: string;
    private _whenOver: Date;
    private _whenRestitute: boolean;
    private _whenContacted: boolean;
    private _publicId: string       = '';
    private _state: Estate          = Estate.Save;
    private _paid: Date             = null;
    private _magasin: string        = null;
    private _bikeLinked: BikeModel  = null;
    private _delay: Date            = null;
    private _isOver: boolean        = false;
    private _reparationFrom: string = null;
    private _receptionFrom: string  = null;
    private _piecesToOrder: string  = null;
    private _workDone: string       = null;
    private _listWork: any          = {};
    private _price: number          = null;
    private _errors: any;
    private _isInsurance: boolean   = false;
    private _isGuarantee: boolean   = false;
    private _notBike: string;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public servService: ServService) {
    };

    static j2o(data, servService: ServService) {
        let serv = new ServModel(servService);

        serv._privateId      = data.privateId;
        serv._about          = data.about;
        serv._created        = new Date(data.created);
        serv._client         = data.client;
        serv._process        = data.state;
        serv._nbrService     = data.nbrService;
        serv._whenOver       = data.whenOver;
        serv._whenRestitute  = data.whenRestitute;
        serv._whenContacted  = data.whenContacted;
        serv._publicId       = data.publicId;
        serv._paid           = data.paid;
        serv._magasin        = data.magasin;
        serv._bikeLinked     = data.bikeLinked;
        serv._delay          = new Date(data.delay);
        serv._isOver         = false;
        serv._reparationFrom = data.reparationFrom;
        serv._receptionFrom  = data.receptionFrom;
        serv._piecesToOrder  = data.piecesToOrder;
        serv._workDone       = data.workDone;
        serv._listWork       = data.listWork;
        serv._price          = data.price;
        serv._isInsurance    = data.isInsurance;
        serv._isGuarantee    = data.isGuarantee;
        serv._notBike        = data.notBike;

        if (data.isOver)
            serv._isOver = true;
        return serv;
    }

    static o2j(serv: ServModel) {

        let tmp = {
            'privateId'     : serv.privateId,
            'about'         : serv.about,
            'paid'          : serv.paid,
            'bikeLinked'    : null,
            'magasin'       : serv.magasin,
            'delay'         : serv.delay,
            'isOver'        : serv.isOver.toString(),
            'reparationFrom': serv.reparationFrom,
            'receptionFrom' : serv.receptionFrom,
            'piecesToOrder' : serv.piecesToOrder,
            'workDone'      : serv.workDone,
            'listWork'      : [],
            'state'         : serv.process,
            'isInsurance'   : serv.isInsurance.toString(),
            'isGuarantee'   : serv.isGuarantee.toString(),
            'notBike'       : serv.notBike
        };

        tmp.delay.setHours(tmp.delay.getHours() + 1);

        let tmpWork = {};
        serv.listWork.forEach(e=> {
            if (e.title) {
                tmpWork = {title: e.title, quantity: "", price: ""};
                if (e.quantity)
                    tmpWork['quantity'] = e.quantity;
                if (e.price)
                    tmpWork['price'] = e.price;
                tmp.listWork.push(tmpWork);
            }
        });

        if (tmp.listWork.length == 0)
            tmp.listWork.push({});

        if (serv.bikeLinked instanceof BikeModel || serv.bikeLinked != null)
            tmp.bikeLinked = BikeModel.o2j(serv.bikeLinked);

        return tmp;
    }

    //*************************************
    //*************** ACTION **************
    //*************************************
    public modelChange() {
        if (this.validate()) {
            this.state = Estate.Saving;
            this.servService.update(this);
            return true;
        } else {
            this.state = Estate.Error;
            return false;
        }
    }

    public toOverWithSMS() {
        this.process = 'over';
        this.servService.update(this);
    }

    public toOverWithoutSMS() {
        this.process = 'over';
        this.servService.update(this);
    }

    public toRestitute() {
        this.process = 'restitute';
        this.servService.update(this);
    }

    public toDelete() {
        this.servService.delete(this);
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public validate(): boolean {
        let validator = new ValidatorService();
        validator
            .addField(this.about, 'about', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42000}}
            ])
            .addField(this.magasin, 'magasin', EvalidatorRequire.Require, [
                {fn: validator.stringLength, options: {min: 1, max: 20}}
            ])
            .addField(this.notBike, 'notBike', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 0, max: 100}}
            ])
            .addField(this.delay, 'delay', EvalidatorRequire.Require, [
                {fn: validator.date, options: {}}
            ])
            .addField(this.reparationFrom, 'reparationFrom', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 2, max: 2}}
            ])
            .addField(this.receptionFrom, 'receptionFrom', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 2, max: 2}}
            ])
            .addField(this.piecesToOrder, 'piecesToOrder', EvalidatorRequire.Optional, [
                {fn: validator.stringLength, options: {min: 1, max: 42000}}
            ])
            .addField(this.listWork, 'listWork', EvalidatorRequire.Optional, [
                {fn: validator.listWork, options: {}}
            ]);
        this._errors = validator.run();
        return (this._errors == null);
    }

    //*************************************
    //*************** METHOD **************
    //*************************************

    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get privateId(): string {
        return this._privateId;
    }

    set privateId(value: string) {
        this._privateId = value;
    }

    get about(): string {
        return this._about;
    }

    set about(value: string) {
        this._about = value;
    }

    get created(): Date {
        return this._created;
    }

    set created(value: Date) {
        this._created = value;
    }

    get client(): any {
        return this._client;
    }

    set client(value: any) {
        this._client = value;
    }

    get clientPrivateId(): string {
        return this._clientPrivateId;
    }

    set clientPrivateId(value: string) {
        this._clientPrivateId = value;
    }

    get process(): string {
        return this._process;
    }

    set process(value: string) {
        this._process = value;
    }

    get nbrService(): string {
        return this._nbrService;
    }

    set nbrService(value: string) {
        this._nbrService = value;
    }

    get whenOver(): Date {
        return this._whenOver;
    }

    set whenOver(value: Date) {
        this._whenOver = value;
    }

    get whenRestitute(): boolean {
        return this._whenRestitute;
    }

    set whenRestitute(value: boolean) {
        this._whenRestitute = value;
    }

    get whenContacted(): boolean {
        return this._whenContacted;
    }

    set whenContacted(value: boolean) {
        this._whenContacted = value;
    }

    get publicId(): string {
        return this._publicId;
    }

    set publicId(value: string) {
        this._publicId = value;
    }

    get state(): Estate {
        return this._state;
    }

    set state(value: Estate) {
        this._state = value;
    }

    get paid(): Date {
        return this._paid;
    }

    set paid(value: Date) {
        this._paid = value;
    }

    get magasin(): string {
        return this._magasin;
    }

    set magasin(value: string) {
        this._magasin = value;
    }

    get bikeLinked(): BikeModel {
        return this._bikeLinked;
    }

    set bikeLinked(value: BikeModel) {
        this._bikeLinked = value;
    }

    get delay(): Date {
        return this._delay;
    }

    set delay(value: Date) {
        this._delay = value;
    }

    get isOver(): boolean {
        return this._isOver;
    }

    set isOver(value: boolean) {
        this._isOver = value;
    }

    get reparationFrom(): string {
        return this._reparationFrom;
    }

    set reparationFrom(value: string) {
        this._reparationFrom = value;
    }

    get receptionFrom(): string {
        return this._receptionFrom;
    }

    set receptionFrom(value: string) {
        this._receptionFrom = value;
    }

    get piecesToOrder(): string {
        return this._piecesToOrder;
    }

    set piecesToOrder(value: string) {
        this._piecesToOrder = value;
    }

    get workDone(): string {
        return this._workDone;
    }

    set workDone(value: string) {
        this._workDone = value;
    }

    get listWork(): any {
        return this._listWork;
    }

    set listWork(value: any) {
        this._listWork = value;
    }

    get price(): number {
        return this._price;
    }

    set price(value: number) {
        this._price = value;
    }

    get errors(): any {
        return this._errors;
    }

    set errors(value: any) {
        this._errors = value;
    }

    get isInsurance(): boolean {
        return this._isInsurance;
    }

    get notBike(): string {
        return this._notBike;
    }

    set notBike(value: string) {
        this._notBike = value;
    }

    set isInsurance(value: boolean) {
        this._isInsurance = value;
    }

    get isGuarantee(): boolean {
        return this._isGuarantee;
    }

    set isGuarantee(value: boolean) {
        this._isGuarantee = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/serv.model.ts